import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=7352ec7f&scoped=true&"
import script from "./PropertyManagement.vue?vue&type=script&lang=ts&"
export * from "./PropertyManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyManagement.vue?vue&type=style&index=0&id=7352ec7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352ec7f",
  null
  
)

export default component.exports